import {Sport} from "modules/types/sport";

export enum ShareTarget {
	Twitter = "tw",
	Facebook = "fb",
}

export enum ShareType {
	General = "general",
	League = "league",
}

export interface IShare {
	target: ShareTarget;
	type: ShareType;
	sport?: Sport;
	leagueId?: number;
	t?: number;
	code?: string;
}
